import createKit from './create-kit';
import search from './search';
import getDetails from './get-details';
import update from './update';
import importItems from './import-items';
import retrieve from './retrieve';
import updateItems from './update-items';
import addUserGroup from './add-user-group';
import removeUserGroup from './remove-user-group';
import deleteKit from './delete-kit';

export default {
	retrieve,
	createKit,
	search,
	getDetails,
	update,
	importItems,
	updateItems,
	addUserGroup,
	removeUserGroup,
	deleteKit
};
